import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import { CartContext } from "@overrides_venia/peregrine/context/cart";
import Button from "@overrides_venia/venia-ui/components/Button";
import { FormattedMessage, useIntl } from "react-intl";
import * as Sentry from "@sentry/react";
import { bgImage } from "@Src_main/utils/generalUtils";
import nonnaWorried from "@Src_main/assets/images/nonna_worried.png";
var ErrorPage = () => {
  var {
    formatMessage
  } = useIntl();
  var sentryReplay = Sentry.getReplay();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100dvh",
      background: "linear-gradient(rgba(237, 229, 213, 0.5), rgba(237, 229, 213, 0.5)), ".concat(bgImage(nonnaWorried)),
      backgroundRepeat: "no-repeat",
      backgroundSize: "75%",
      backgroundPosition: "bottom"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column uk-margin-auto uk-flex-middle "
  }, /*#__PURE__*/React.createElement("h2", {
    className: "uk-title uk-margin-large-top"
  }, formatMessage({
    id: "error.overtitle"
  })), /*#__PURE__*/React.createElement("h1", {
    className: "uk-text-large uk-margin-small-top"
  }, formatMessage({
    id: "error.title"
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-title uk-padding uk-padding-small-bottom"
  }, formatMessage({
    id: "error.subtitle"
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-title uk-padding uk-padding-remove-top"
  }, formatMessage({
    id: "error.subtitle.cont"
  })), sentryReplay !== null && sentryReplay !== void 0 && sentryReplay.getReplayId() ? /*#__PURE__*/React.createElement("div", {
    className: " uk-position-bottom uk-margin-xlarge-bottom uk-title uk-text-small uk-padding uk-text-muted uk-text-dimgray"
  }, /*#__PURE__*/React.createElement("p", null, "Sentry Replay ID ", sentryReplay.getReplayId()), formatMessage({
    id: "error.sentry.explanation"
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "uk-position-small uk-position-bottom "
  }, /*#__PURE__*/React.createElement(Button, {
    id: "miniCartButton",
    color: "miscusi_red",
    type: "button",
    fullScreen: true,
    onClick: () => window.location.reload()
  }, formatMessage({
    id: "error.button.cta"
  })))));
};
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    console.error(error, info);
    exponea.track("app_error", {
      event_type: "error",
      timestamp: Date.now(),
      location: window.location.href,
      cart_id: this.context[0].cartId,
      error_message: error.message,
      error_stack: error.stack
    });
    Sentry.withScope(scope => {
      scope.setLevel("fatal");
      scope.setTag("error_type", "fatal");
      scope.setTag("location", window.location.href);
      scope.setTag("cart_id", this.context[0].cartId);
      Sentry.captureException(error);
      var replay = Sentry.getReplay();
      replay.flush();
      Sentry.flush();
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement(ErrorPage, null);
    }
    return this.props.children;
  }
}
_defineProperty(ErrorBoundary, "contextType", CartContext);